import { AppRoute } from 'src/routes/AppRoute';
import React from 'react';
import { TAppRouteProps } from 'src/routes/routes.config';

export const PublicRoute: React.FC<TAppRouteProps> = (props) => {
  // Custom logic may be added in future
  return <AppRoute {...props} />;
};
